import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadCategoriasItemsDeCompras } from '../../../store/slices/configuracionesSlice';
import CategoriasConfigBody from './CategoriasConfigBody';

const CategoriasItemsDeComprasConfig = (props) => {
  const dispatch = useDispatch();
  const categorias = useSelector(state => state.configuraciones.loadCategoriasItemsDeCompras.items);
  const loading = useSelector(state => state.configuraciones.loadCategoriasItemsDeCompras.loading);
  const onLoad = (empresaId) => dispatch(loadCategoriasItemsDeCompras(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <CategoriasConfigBody
      categorias={categorias}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default CategoriasItemsDeComprasConfig;